export default {
    create: "Create account",
    exp: "Enter your email address, and we’ll send you a link to get set up",
    "have-acc": "Have an account?",
    login: "Log in",
};
